<!--
  - Copyright Huesik (c) 2019.
  - 맵 화면 우측의 고시원 리스트 화면입니다.
  -->

<template>
  <div class="kosiwon-search-list-wrapper" :class="{'iOS-app': isiOSNative, 'hide' : !isShowList, 'small-up': openStatus === 'small', 'full-up': openStatus === 'full'}">
    <div class="show-kosiwon-list-btn" @click="toggleStatus">이 지역 고시원 전체보기</div>
    <div class="scrolling-view" v-show="isShowList">
      <ul v-infinite-scroll="loadNext" infinite-scroll-disabled="busy" infinite-scroll-distance="10" ref="scrollView" v-if="searchKosiwonList.length > 0">
        <div v-for="(kosiwon, index) in kosiwonScrollList" :key="`__KOSIWON__${kosiwon.pk}`">
          <h5 class="list-title suggest" v-if="packageList.length > 0 && index === 0">추천 고시원<i class="question" @click="openSuggestionInfoModal"></i>
          </h5>
          <h5 class="list-title grey" v-if="index === packageItemLength">일반 고시원</h5>
          <li class="suggestion-kosiwons-item" @mouseover.prevent="$mq !== 'sm' ? setHoverKosiwon(kosiwon) : null" @click.prevent="moveToDetail(kosiwon.pk)">
            <div>
              <div class="kosiwons-image-wrapper">
                <img :src="kosiwon.thumbnail_url" v-if="kosiwon.thumbnail_url"/>
                <img src="../../assets/images/list-thumbnail-none.png" v-else/>
              </div>
              <kosiwon-information-fragments
                :kosiwon-information="kosiwon"
                :isShowDesc="true"
                :style="{textAlign: 'left', 'padding': '0 0 0 2rem'}"
              />
            </div>
          </li>
        </div>
      </ul>
      <div class="no-data-view" v-else>
        <img src="../../assets/images/ex-graylogo.png"/>
        <p>해당 위치에 고시원이 없습니다.</p>
      </div>
    </div>
    <button class="toggle-view-btn" :class="{'hide-btn': isShowList, 'show-btn': !isShowList}" @click="toggleListView"></button>
    <suggest-kosiwon-info-modal />
  </div>
</template>

<script>
  // import KosiwonSearchItem from './KosiwonSearchItem'
  import KosiwonInformationFragments from '../../components/Kosiwons/KosiwonInformationFragments'
  import _ from 'underscore'
  import VueSticky from 'vue-sticky'
  import EventBus from '../../core/modules/eventBus'


  import { mapState } from 'vuex'
  import SuggestKosiwonInfoModal from '../Modal/SuggestKosiwonInfoModal'
  import DynamicNavigator from '../../core/modules/DynamicNavigator'
  export default {
    name: 'KosiwonSearchListView',
    components: {SuggestKosiwonInfoModal, KosiwonInformationFragments},
    directives: {
      'sticky': VueSticky
    },
    data () {
      return {
        kosiwonScrollList: [],
        packageList: [],
        busy: false,
        index: 0,
        distance: 10,
        packageItemLength: 0,
        isShowPackageHeader: false,
        isShowList: true
      }
    },
    computed: {
      ...mapState({
        // Vuex에서 kosiwon List 가 변경될 때 해당 화면도 갱신합니다.
        searchKosiwonList: state => state.SEARCH.KOSIWON_LIST,
        openStatus: state => state.SEARCH.OPEN_STATUS,
      }),
      isiOS () {
        return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
      },
      isiOSNative () {
        return this.$store.state.APP.IS_NATIVE && this.isiOS
      }
    },
    watch: {
      searchKosiwonList () {
        this.index = 0
        this.kosiwonScrollList = []
        // 고시원 리스트에서 패키지만 추려서 상위에 보여준다.
        // 이미 서버에서 정렬은 패키지만 우선순위로 하기때문에 갯수만 측정해서 화면에 보여준다.
        this.packageList = _.filter(this.searchKosiwonList, (kosiwon) => {
          return ['H', 'M'].includes(kosiwon.package_type);
        });

        this.packageItemLength = this.packageList.length
        if(this.$refs.scrollView) {
          this.$refs.scrollView.scrollTop = 0
        }
        this.loadNext()
      },
    },
    methods: {
      setHoverKosiwon (kosiwon) {
        this.$store.dispatch('setHoverKosiwon', kosiwon)
      },
      loadNext () {
        console.log(this.index)
        this.busy = true
        this.kosiwonScrollList = this.kosiwonScrollList.concat(this.searchKosiwonList.slice(this.index * this.distance, (this.index * this.distance + this.distance)))
        this.index += 1
        this.busy = false
      },
      moveToDetail (pk) {
        let routeData = this.$router.resolve(`/detail/${pk}`)
        DynamicNavigator.getInstance().moveToDetail(routeData.href, this.$router)
      },
      toggleListView () {
        this.isShowList = !this.isShowList
        EventBus.$emit('toggleListView')
      },
      openSuggestionInfoModal() {
        this.$modal.show('suggestion-kosiwon-info-modal')
      },
      toggleStatus () {
        EventBus.$emit('clearClickedMapObject')
        if (this.openStatus !== 'full') {
          this.$store.dispatch('setOpenStatus', 'full')
        } else {
          this.$store.dispatch('setOpenStatus', '')
        }
      }
    },
    mounted () {
      this.$store.dispatch('setOpenStatus', '')
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";

  .kosiwon-search-list-wrapper {
    border-left: 1px solid @very-light-pink-two;
    max-width: 70rem;
    min-width: 55rem;
    width: 40%;
    background: @white;
    position: relative;

    &.hide {
      width: initial;
      min-width:0;
    }

    .list-title {
      // height: 2rem;
      background-color: @windows-blue;
      color: white;
      text-align: left;
      vertical-align: middle;
      padding: 1.5rem 2.6rem;
      font-size: 1.8rem;
      line-height: 2rem;

      &.grey {
        background-color: @greyish-brown;
      }

      &.suggest {
        position: relative;
        .question {
          padding: 2rem;
          z-index: 1;
          background-image: url(../../assets/images/ex-question.png);
          background-position: center;
          background-size: 2rem 2rem;
          background-repeat: no-repeat;
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
        }
      }
    }
    .show-kosiwon-list-btn {
      display: none;
    }
    .scrolling-view {
      height: calc(100%);

      ul {
        height:100%;
        overflow-y: auto;
        overflow-x: hidden;
        display: block;
        position: relative;

        .suggestion-kosiwons-item {
          border-bottom: 1px solid #eaeaea;
          cursor: pointer;

          > div {
            display: flex;
            padding: 2rem;
            .kosiwons-image-wrapper {
              height:100%;
              width: 100%;
              overflow: hidden;
              position: relative;
              padding-top: 31%;
              max-width: 22rem;
              min-width: 22rem;

              img {
                width:100%;
                position: absolute;
                margin: auto;
                min-height: 100%;
                min-width: 100%;

                /* For the following settings we set 100%, but it can be higher if needed
                See the answer's update */
                left: -100%;
                right: -100%;
                top: -100%;
                bottom: -100%;
              }
            }
          }
        }
      }
      .no-data-view {
        display: flex;
        height:100%;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        background: @very-light-pink;

        p {
          padding-top: 2rem;
          color: @brown-grey
        }
      }
    }
    .toggle-view-btn {
      width: 2rem;
      height: 5rem;
      background-color: @white;
      position: absolute;
      top: 0;
      bottom: 0;
      left: -2rem;
      margin: auto;
      z-index: 1;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: .7rem 0 0 .7rem;
      border: 1px solid @very-light-pink-two;
      border-right: 0;
      &.hide-btn {
        background-image: url("../../assets/images/ex-hide.png");
      }

      &.show-btn {
        background-image: url("../../assets/images/ex-show.png");
      }
    }

    .slide-leave-active,
    .slide-enter-active {
      transition: 1s;
    }
    .slide-enter {
      transform: translate(100%, 0);
    }
    .slide-leave-to {
      transform: translate(0, 0);
    }
  }
</style>
<style scoped lang="less" >
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    .kosiwon-search-list-wrapper {
      position: absolute;
      height: 5rem;
      top: calc(100% - 8rem - 3rem);
      max-width: initial;
      min-width: initial;
      width: 100%;
      z-index: 1;

      &.iOS-app {
        top: calc(100% - 2rem - 3rem);
        &.full-up {
          height: calc(100% - 8rem - 2.6rem);
        }
        &.small-up {
          height: 50%;
        }
      }

      &.small-up {
        top: 50%;
        height: calc(50% - 6rem);
        .scrolling-view {
          height: calc(100% - 5rem);
          display: block;
        }
      }

      &.full-up {
        top: 10.6rem;
        height: calc(100% - 8rem - 8.6rem);
        .scrolling-view {
          height: calc(100% - 5rem);
          display: block;
        }
        .show-kosiwon-list-btn {
          &:after {
            background: url("../../assets/images/ex-down.png") no-repeat no-repeat center center;
          }
        }
      }

      .list-title {
        // height: 3rem;
        padding: 0.9rem 1rem;
        line-height: 3rem;
        font-weight: bold;
        &.suggest .question {
          padding: 1rem;
          background-size: 2rem;
          right: 1rem;
        }
      }
      .show-kosiwon-list-btn {
        display: block;
        height: 5rem;
        text-align: left;
        padding: 0 1rem;
        line-height: 5rem;
        position: relative;
        color: @black-two;
        border-bottom: 1px solid @very-white;

        &:after {
          content: '';
          background: url("../../assets/images/ex-up.png") no-repeat no-repeat center center;
          background-size: 1.5rem 0.8rem;
          position: absolute;
          right: 1.2rem;
          top: 0;
          width:2rem;
          height:100%;
        }
      }
      .scrolling-view {
        height: 0;
        display: none;
        ul {
          -webkit-overflow-scrolling: touch;
          .suggestion-kosiwons-item {
            > div {
              padding: 1.1rem 1.2rem;
              .kosiwons-image-wrapper {
                flex: 1;
                min-width: 18.75rem;
                max-width: 18.75rem;
                img {
                  width: 100%;
                }
              }
              .kosiwons-information-wrapper {
                flex: 1.15;
                min-width: calc(100% - 18.75rem - 2rem - 1.12rem);
              }
            }
          }
        }
        .no-data-view {
          img {
            width: 50%;
          }
        }
      }
      .toggle-view-btn {
        display: none;
      }
    }
  }
</style>
<style lang="less" scoped>
  /* 아이패드 미니 세로 */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio: 1) {
    .kosiwon-search-list-wrapper .scrolling-view ul .suggestion-kosiwons-item > div .kosiwons-image-wrapper {
      max-width: 35rem;
    }
  }
</style>

